import { render, staticRenderFns } from "./subjectType.vue?vue&type=template&id=1e23ee00&"
import script from "./subjectType.vue?vue&type=script&lang=js&"
export * from "./subjectType.vue?vue&type=script&lang=js&"
import style0 from "./subjectType.vue?vue&type=style&index=0&id=1e23ee00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports